<template>
  <img
    v-if="url"
    class="magic-ui-qr-code"
    :src="url"
  >
</template>

<script>
export default {
  name: 'MagicUiQrCode',

  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },

    model: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
  },

  computed: {
    url() {
      const { config } = this;

      let { url } = config;

      if (this.config.params) {
        const params = [];
        Object.entries(this.config.params).forEach(([key, value]) => {
          params.push(`${key}=${value}`);
        });
        url = `${url}?${params.join('&')}`;
      }
      return `https://vip.video.qq.com/fcgi-bin/comm_cgi?name=short_url&url=${window.encodeURIComponent(url)}&need_short_url=${config.needShortUrl ? 1 : 0}&need_qrcode=1&margin=1`;
    },
  },
};
</script>
